module.exports = __webpack_public_path__ + "assets/img/limeclinic-2.c8a9a692.png";